import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    align-self: center;
    display: flex;
    gap: 8px;
    height: 100%;
    flex-direction: column;
    font-family: ${theme.v2.font.family.primary};
    justify-content: center;
    max-width: 600px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      margin-bottom: 64px;
    }
  `};
`;

export const ModalStatusTitle = styled.h3`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
    text-align: center;
  `};
`;

export const ModalStatusInfo = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xs};
    margin: 0;
    text-align: center;
  `};
`;

export const ButtonsWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 32px;
    margin-top: 16px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      flex-direction: column;
      margin-top: 24px;
    }
  `}
`;

export const PageNotLoaded = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    display: block;
    font-size: ${theme.v2.font.sizes.xxs};
    margin-top: 24px auto 0px;
    text-align: center;
  `}
`;
